import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "v-col-6 v-col-md-3" }
const _hoisted_3 = { class: "p-2" }

import Api from '@/services/api'
    import { h, onBeforeMount, watch } from 'vue'
    import { ref } from 'vue';
    import { ElBadge, ElButton, ElMessageBox, ElRow } from 'element-plus';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import { Withdraw } from '@/services/types/affiliate';
    import ModalComponent from '@/components/modals/ModalComponent.vue';
    import WithdrawView from '@/components/modals/views/WithdrawView.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WithdrawsView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Withdraw>>(defaultPaginated)
    const status = ref<'sent' | 'pending' | 'all'>('pending')
    const withdraw = ref<Withdraw | null>(null)
    const page = ref<number>(1)

    const getWithdraws = async () => {
        console.log("Okay")
        loading.value = true
        console.log(status.value)
        const res = await Api.get(`admin/affiliates/withdraws/getAll?page=${page.value}&status=${status.value}`)
        if (res.status == 200) {
            data.value = res.data.withdraws
            console.log(res.data.withdraws)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            console.log(res)
        }
        loading.value = false
    }

    const changePage = (p: number) => {
        page.value = p
        getWithdraws()
    }

    const openWithdraw = (row: any) => {
        // okay
        withdraw.value = row
    }

    onBeforeMount(() => {
        getWithdraws()

        document.title = "Levantamentos"
    })

    watch(status, () => {
        page.value = 1
        getWithdraws()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Pedidos de levantamento de afiliados" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElRow), { class: "py-2" }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "v-col-6 v-col-md-9 me-3" }, "Estado do pedido", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_radio_group, {
                modelValue: status.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "all",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("Todos", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "sent",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Pagos", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "pending",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Pendentes", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(PaginatedTable, {
          loading: loading.value,
          page: data.value.current_page,
          "show-rows": 10,
          pages: data.value.last_page,
          data: data.value.data,
          cols: [
            ],
          onChange: changePage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Afiliado",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.affiliate.user.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Valor",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.value.toFixed(2)) + "MT ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Data e hora",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Estado",
              "class-name": "auto text-center",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", {
                  style: {"border-radius":"10px"},
                  class: _normalizeClass(["pa-2 px-4 text-light", {'bg-success': data.row.sent, 'bg-danger': !data.row.sent}])
                }, _toDisplayString(data.row.sent ? 'Enviado':'Pendente'), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    onClick: ($event: any) => (openWithdraw(data.row)),
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "page", "pages", "data"])
      ]),
      _: 1
    }),
    (withdraw.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = () => {withdraw.value = null}),
          cardclass: "col-12 col-md-6 col-lg-5 col-x-lg-4",
          header: "Informações do pedido"
        }, {
          default: _withCtx(() => [
            _createVNode(WithdrawView, {
              withdraw: withdraw.value,
              onUpdate: _cache[1] || (_cache[1] = (w) => {
                (withdraw.value as Withdraw).sent = w.sent; 
                (withdraw.value as Withdraw).transaction_id = w.transaction_id
            })
            }, null, 8, ["withdraw"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})